import Model from '../Model'
import moment from "moment";

export default class ScopeOfWorks extends Model {
    getFormAttributes() {
        return this;
    }

    static parseAttributes(attributes = {}) {
        return attributes;
    }

    setAttributes(attributes) {
        super.setAttributes(attributes);
        let tokens = [];
        this.tokens = tokens.join("|").toLowerCase();
    }

    static async find(packageReference) {
        const data = await Http.get(route("api.v2.project-delivery.scope-of-works", [packageReference]));
        return this.make(data);
    }
}
